<script>
import TabLayout from "../Shared/TabLayout";
import TextInput from "@/Shared/TextInput";
import FormError from "@/Shared/FormError.vue";

export default {
    metaInfo: {title: Lang.get('employeedashboard::pages/settings/two-factor-authentication.title')},
    components: { TabLayout, TextInput, FormError },
    props: {
        errors: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                'code': null,
            }),
        }
    },
    methods: {
        submit() {
            this.form.post(
                route('nl.employeedashboard.settings.two-factor-authentication.disable.post'),
            );
        },
    },
}
</script>

<template>
    <tab-layout
        :title="Lang.get('employeedashboard::pages/settings/two-factor-authentication.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/two-factor-authentication.subtitle')"
        tabName="two-factor-authentication"
        :hideMsg="true"
    >
        <p class="font-poppins font-weight-light color-dark-blue">
            {{ Lang.get('employeedashboard::pages/settings/two-factor-authentication.disable.information') }}
        </p>

        <form @submit.prevent="submit" class="mt-3">
            <text-input
                id="code"
                v-model="form.code"
                :placeholder="Lang.get('employeedashboard::shared.placeholder.2fa_code')"
                :label="Lang.get('employeedashboard::pages/settings/two-factor-authentication.disable.form.code')"
                :error="errors['code']"
            />

            <div class="d-flex mt-3">
                <input class="btn btn-danger font-poppins font-weight-bold border-radius-19"
                       type="submit"
                       :disabled="form.processing"
                       :value="Lang.get('employeedashboard::pages/settings/two-factor-authentication.disable.form.submit')"
                >

                <inertia-link
                    type="button"
                    class="btn btn-orange-outlined font-poppins font-weight-bold border-radius-19 ml-3"
                    :href="route('nl.employeedashboard.settings.two-factor-authentication.index')"
                >
                    {{ Lang.get('employeedashboard::pages/settings/two-factor-authentication.disable.form.cancel') }}
                </inertia-link>
            </div>
        </form>
    </tab-layout>

</template>
